import { createJob, updateJob, deleteJob as deleteJobDoc, toggleJobActive, subscribeLatestJobs, fetchMoreJobs } from "../services/jobService";
import { subscribeMessages, sendMessage } from "../services/chatService";
import { subscribeLatestUsers, fetchMoreUsers } from "../services/userService";
import { subscribeTaikenApplications } from "../services/taikenService";
import { useState, useRef, useEffect } from "react";
import { auth } from "../config/firebase";
import { signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import { ICON_MD } from "../constants/icons";




/* ── Dummy Data ── */
// Users loaded from Firestore

// Taiken list loaded from Firestore

const STATUS_COLORS = {
  "新規登録": { bg: "rgba(74,222,128,.12)", color: "#4ade80" },
  "求人紹介待ち": { bg: "rgba(212,175,110,.12)", color: "#d4af6e" },
  "求人紹介済み": { bg: "rgba(96,165,250,.12)", color: "#60a5fa" },
  "体験入店調整中": { bg: "rgba(251,146,60,.12)", color: "#fb923c" },
  "体験入店完了": { bg: "rgba(168,85,247,.12)", color: "#a855f7" } };

const TAIKEN_COLORS = {
  "確定": { bg: "rgba(74,222,128,.12)", color: "#4ade80" },
  "調整中": { bg: "rgba(251,146,60,.12)", color: "#fb923c" },
  "完了": { bg: "rgba(168,85,247,.12)", color: "#a855f7" } };

/* ── Components ── */
function Sidebar({ active, onNav, collapsed, onToggle, onLogout }) {
  const items = [
    { id: "users", icon: "👥", label: "ユーザー一覧" },
    { id: "jobs", icon: "💼", label: "求人管理" },
    { id: "taiken", icon: "🏠", label: "体験入店管理" },
  ];
  return (
    <div className={`adm-side ${collapsed ? "adm-side--collapsed" : ""}`}>
      <div className="adm-side__logo">
        <img src={ICON_MD} alt="DW" className="adm-side__logo-img" />
        {!collapsed && <span className="adm-side__logo-text">DressWork<small>管理画面</small></span>}
      </div>
      <nav className="adm-side__nav">
        {items.map(it => (
          <button key={it.id} className={`adm-side__item ${active === it.id ? "adm-side__item--active" : ""}`} onClick={() => onNav(it.id)}>
            <span className="adm-side__icon">{it.icon}</span>
            {!collapsed && <span className="adm-side__label">{it.label}</span>}
          </button>
        ))}
      </nav>
      <button className="adm-side__toggle" onClick={onToggle}>{collapsed ? "→" : "←"}</button>
      {!collapsed && <button className="adm-side__logout" onClick={onLogout}>ログアウト</button>}
    </div>
  );
}

function MobileNav({ active, onNav }) {
  return (
    <div className="adm-mnav">
      {[{ id: "users", icon: "👥", label: "ユーザー" }, { id: "jobs", icon: "💼", label: "求人" }, { id: "taiken", icon: "🏠", label: "体験入店" }].map(it => (
        <button key={it.id} className={`adm-mnav__item ${active === it.id ? "adm-mnav__item--active" : ""}`} onClick={() => onNav(it.id)}>
          <span>{it.icon}</span><span>{it.label}</span>
        </button>
      ))}
    </div>
  );
}

function UserList({users, onSelect, selectedId, hasMoreUsers, loadingMoreUsers, loadMoreUsers}) {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const filtered = users.filter(u => {
    if (filter !== "all" && u.status !== filter) return false;
    if (search && !u.name.includes(search) && !u.area.includes(search)) return false;
    return true;
  });
  return (
    <div className="adm-ulist">
      <div className="adm-ulist__header">
        <h2 className="adm-ulist__title">ユーザー一覧 <span className="adm-ulist__count">{filtered.length}件</span></h2>
      </div>
      <div className="adm-ulist__filters">
        <input className="adm-search" placeholder="名前・エリアで検索..." value={search} onChange={e => setSearch(e.target.value)} />
        <select className="adm-select" value={filter} onChange={e => setFilter(e.target.value)}>
          <option value="all">すべて</option>
          <option value="新規登録">新規登録</option>
          <option value="求人紹介待ち">求人紹介待ち</option>
          <option value="求人紹介済み">求人紹介済み</option>
          <option value="体験入店調整中">体験入店調整中</option>
          <option value="体験入店完了">体験入店完了</option>
        </select>
      </div>
      <div className="adm-ulist__list">
        {filtered.map(u => (
          <div key={u.id} className={`adm-ucard ${selectedId === u.id ? "adm-ucard--active" : ""}`} onClick={() => onSelect(u)}>
            <div className="adm-ucard__avatar">{u.name[0]}</div>
            <div className="adm-ucard__info">
              <div className="adm-ucard__name">{u.name} <span className="adm-ucard__age">{u.age}</span></div>
              <div className="adm-ucard__meta">{u.area} ・ {u.date}</div>
            </div>
            <div className="adm-ucard__right">
              <span className="adm-ucard__status" style={{ background: STATUS_COLORS[u.status]?.bg, color: STATUS_COLORS[u.status]?.color }}>{u.status}</span>
              {u.unread > 0 && <span className="adm-ucard__badge">{u.unread}</span>}
            </div>
          </div>
        ))}
        <div style={{ textAlign: "center", padding: "14px 0" }}>
          {hasMoreUsers && (
            <button className="adm-ulist__btn" onClick={loadMoreUsers} disabled={loadingMoreUsers} style={{ opacity: loadingMoreUsers ? 0.6 : 1 }}>
              {loadingMoreUsers ? "読み込み中..." : "もっと見る"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function UserDetail({ user, onBack, onSendJob }) {
  const [tab, setTab] = useState("info");
  const [msg, setMsg] = useState("");
  const [chatMsgs, setChatMsgs] = useState([]);
  const chatRef = useRef(null);

  useEffect(() => {
    if (tab !== "chat") return;
    const unsubscribe = subscribeMessages(user.id, (msgs) => {
      setChatMsgs(msgs.map(m => ({ from: m.senderType, text: m.text, type: m.type, metadata: m.metadata })));
    });
    return () => unsubscribe();
  }, [tab, user.id]);

  useEffect(() => { chatRef.current?.scrollTo({ top: chatRef.current.scrollHeight }); }, [chatMsgs, tab]);

  const sendMsg = async () => {
    if (!msg.trim()) return;
    const text = msg.trim();
    setMsg("");
    try {
      await sendMessage(user.id, {
        senderId: "staff",
        senderType: "staff",
        text,
        type: "text" });
    } catch (e) {
      console.error("Send error:", e);
    }
  };

  const [viewPhoto, setViewPhoto] = useState(null);

  const sendImage = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const { compressImage } = await import("../services/imageUtil");
      const compressed = await compressImage(file);
      const { ref, uploadBytes, getDownloadURL } = await import("firebase/storage");
      const { storage } = await import("../config/firebase");
      const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, "_");
      const storageRef = ref(storage, "chatImages/staff/" + user.id + "/" + Date.now() + "_" + safeName);
      const snap = await uploadBytes(storageRef, compressed);
      const url = await getDownloadURL(snap.ref);
      await sendMessage(user.id, {
        senderId: "staff",
        senderType: "staff",
        text: "",
        type: "image",
        metadata: { imageUrl: url },
      });
    } catch (e) {
      console.error("Image send error:", e);
    }
    e.target.value = "";
  };

  return (
    <div className="adm-detail">
      <div className="adm-detail__header">
        <button className="adm-detail__back" onClick={onBack}>← 戻る</button>
        <div className="adm-detail__user">
          <div className="adm-detail__avatar">{user.name[0]}</div>
          <div>
            <div className="adm-detail__name">{user.name} <span>{user.age}</span></div>
            <span className="adm-detail__status" style={{ background: STATUS_COLORS[user.status]?.bg, color: STATUS_COLORS[user.status]?.color }}>{user.status}</span>
          </div>
        </div>
        <button className="adm-detail__send-btn" onClick={() => onSendJob(user)}>求人を送る</button>
      </div>

      <div className="adm-detail__tabs">
        {[{ id: "info", label: "条件" }, { id: "chat", label: "チャット" }].map(t => (
          <button key={t.id} className={`adm-detail__tab ${tab === t.id ? "adm-detail__tab--active" : ""}`} onClick={() => setTab(t.id)}>{t.label}</button>
        ))}
      </div>

      {tab === "info" && (
        <div className="adm-detail__info">
          {/* ユーザー写真 */}
          {user.photoUrls && user.photoUrls.length > 0 && (
            <div className="adm-info-section">
              <h4 className="adm-info-section__title">写真</h4>
              <div className="adm-info-photos">
                {user.photoUrls.map((url, i) => (
                  <img key={i} src={url} alt={`写真${i + 1}`} className="adm-info-photo" />
                ))}
              </div>
            </div>
          )}
          <div className="adm-info-section">
            <h4 className="adm-info-section__title">プロフィール</h4>
            {[
              ["年齢", user.age],
              ["身長", user.height],
              ["体重", user.weight],
            ].filter(([k, v]) => v).map(([k, v]) => (
              <div key={k} className="adm-info-row"><span className="adm-info-row__k">{k}</span><span className="adm-info-row__v">{v}</span></div>
            ))}
          </div>
          <div className="adm-info-section">
            <h4 className="adm-info-section__title">希望条件</h4>
            {[
              ["経験", user.experience], ["エリア", user.area], ["希望時給", user.salary],
              ["出勤", user.schedule], ["重視ポイント", user.priority],
            ].filter(([k, v]) => v).map(([k, v]) => (
              <div key={k} className="adm-info-row"><span className="adm-info-row__k">{k}</span><span className="adm-info-row__v">{v}</span></div>
            ))}
          </div>
          {(user.phone || user.line) && (
            <div className="adm-info-section">
              <h4 className="adm-info-section__title">連絡先</h4>
              {[
                ["電話番号", user.phone], ["LINE ID", user.line],
              ].filter(([k, v]) => v).map(([k, v]) => (
                <div key={k} className="adm-info-row"><span className="adm-info-row__k">{k}</span><span className="adm-info-row__v">{v}</span></div>
              ))}
            </div>
          )}
        </div>
      )}

      {tab === "chat" && (
        <div className="adm-detail__chat">
          <div className="adm-chat__msgs" ref={chatRef}>
            {chatMsgs.map((m, i) => (
              <div key={i} className={`adm-chat__msg ${m.from === "staff" || m.from === "ai" ? "adm-chat__msg--staff" : "adm-chat__msg--user"}`}>
                {m.from === "user" && <div className="adm-chat__msg-avatar">{user.name[0]}</div>}{m.from === "ai" && <div className="adm-chat__msg-avatar">AI</div>}
                <div className={`adm-chat__msg-bubble ${m.from === "staff" || m.from === "ai" ? "adm-chat__msg-bubble--staff" : "adm-chat__msg-bubble--user"}`}>{
                  m.type === "job_card" && m.metadata ? (
                    <div>
                      <div style={{fontSize:"10px",opacity:0.7,marginBottom:"4px"}}>💼 求人紹介</div>
                      <div style={{fontWeight:700}}>{m.metadata.shopName}</div>
                      <div style={{fontSize:"12px",opacity:0.8}}>{m.metadata.area} / 時給 {m.metadata.salary}</div>
                      {m.text && <div style={{fontSize:"12px",marginTop:"6px",opacity:0.7,fontStyle:"italic"}}>{m.text}</div>}
                    </div>
                  ) : m.type === "image" && m.metadata?.imageUrl ? (
                    <img src={m.metadata.imageUrl} alt="" className="adm-chat__img" onClick={() => setViewPhoto(m.metadata.imageUrl)} />
                  ) : m.text
                }</div>
              </div>
            ))}
          </div>
          <div className="adm-chat__input">
            <label className="adm-chat__img-btn">
              📷
              <input type="file" accept="image/*" onChange={sendImage} style={{ display: "none" }} />
            </label>
            <textarea value={msg} onChange={e => { setMsg(e.target.value); e.target.style.height = "auto"; e.target.style.height = Math.min(e.target.scrollHeight, 120) + "px"; }} placeholder="メッセージを入力..." className="adm-chat__field" rows={1} />
            <button onClick={sendMsg} className="adm-chat__send">送信</button>
          </div>
        </div>
      )}
      {viewPhoto && (
        <div className="adm-photo-viewer" onClick={() => setViewPhoto(null)}>
          <img src={viewPhoto} alt="" className="adm-photo-viewer__img" />
          <button className="adm-photo-viewer__close" onClick={() => setViewPhoto(null)}>×</button>
        </div>
      )}
    </div>
  );
}

function SendJobModal({ user, onClose }) {
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [comment, setComment] = useState("");
  const selectedCount = jobs.filter(j => j.checked).length;

  const toggle = (jobId) => {
    setJobs(prev => prev.map(j => j.id === jobId ? { ...j, checked: !j.checked } : j));
  };

  useEffect(() => {
    const unsub = subscribeLatestJobs(({ items }) => {
      setJobs((items || []).filter(j => j.active !== false).map(j => ({
        id: j.id,
        name: j.shopName || "",
        area: j.area || "",
        salary: j.salaryDisplay || "",
        genre: j.genre || "",
        tags: j.tags || [],
        staffComment: j.staffComment || "",
        photoUrls: j.photoUrls || [],
        checked: false,
      })));
    }, 50, true);
    return () => unsub();
  }, []);
  const sendJobs = async () => {
    setSending(true);
    try {
      const selectedJobs = jobs.filter(j => j.checked);

      if (comment.trim()) {
        await sendMessage(user.id, {
          senderId: "staff",
          senderType: "staff",
          text: comment.trim(),
          type: "text"
        });
      }

      // Send each job as a job card with its own staffComment
      for (const job of selectedJobs) {
        await sendMessage(user.id, {
          senderId: "staff",
          senderType: "staff",
          text: job.staffComment || "",
          type: "job_card",
          metadata: {
            jobId: job.id,
            shopName: job.name,
            area: job.area,
            salary: job.salary,
            genre: job.genre,
            tags: job.tags,
            staffComment: job.staffComment || "",
            photoUrls: job.photoUrls
          }
        });
      }

      setSent(true);
    } catch (e) {
      console.error("Send jobs error:", e);
      alert("送信に失敗しました。");
    }
    setSending(false);
  };
return (
    <div className="adm-modal-overlay" onClick={onClose}>
      <div className="adm-modal" onClick={e => e.stopPropagation()}>
        {!sent ? (<>
          <div className="adm-modal__header">
            <h3>求人を送信 → {user.name}さん</h3>
            <button className="adm-modal__close" onClick={onClose}>×</button>
          </div>
          <div className="adm-modal__body">
            <p className="adm-modal__hint">送信する求人を選択してください（複数可）</p>
            <div className="adm-modal__jobs">
              {jobs.map(j => (
                <div key={j.id} className={`adm-modal__job ${j.checked ? "adm-modal__job--checked" : ""}`} onClick={() => toggle(j.id)}>
                  <div className="adm-modal__job-check">{j.checked ? "✓" : ""}</div>
                  <div><div className="adm-modal__job-name">{j.name}</div><div className="adm-modal__job-meta">{j.area} ・ 時給 {j.salary}</div></div>
                </div>
              ))}
            </div>
            <textarea className="adm-modal__textarea" placeholder="全体の説明を入力（求人カードの前に表示されます）..." value={comment} onChange={e => setComment(e.target.value)} rows={3} />
            <button className="adm-modal__submit" disabled={selectedCount === 0 || sending} style={{ opacity: selectedCount > 0 && !sending ? 1 : 0.3 }} onClick={sendJobs}>
              {sending ? "送信中..." : `${selectedCount}件の求人を送信`}
            </button>
          </div>
        </>) : (
          <div className="adm-modal__body adm-modal__done">
            <div className="adm-modal__done-check">✓</div>
            <h3>送信完了</h3>
            <p>{user.name}さんに{selectedCount}件の求人を送信しました。</p>
            <button className="adm-modal__submit" onClick={onClose}>閉じる</button>
          </div>
        )}
      </div>
    </div>
  );
}

function JobManager() {
  const [jobs, setJobs] = useState([]);
  const [jobsLastDoc, setJobsLastDoc] = useState(null);
  const [loadingMoreJobs, setLoadingMoreJobs] = useState(false);
  const [hasMoreJobs, setHasMoreJobs] = useState(true);
const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const unsub = subscribeLatestJobs(({ items, lastDoc }) => {
      const data = items || [];
      setJobs(data.map(j => ({
        id: j.id,
        name: j.shopName || j.name || "",
        area: j.area || "",
        genre: j.genre || "",
        salary: j.salaryDisplay || j.salary || "",
        tags: j.tags || [],
        staffComment: j.staffComment || "",
        active: j.active !== false,
        photo: !!(j.photoUrls && j.photoUrls.length > 0) || !!j.photoUrl,
        photoUrls: j.photoUrls || (j.photoUrl ? [j.photoUrl] : [])
      })));

      setJobsLastDoc(lastDoc || null);
      setHasMoreJobs(!!lastDoc);
    }, 50, false);

    return () => unsub();
  }, []);
const loadMoreJobs = async () => {
    if (!hasMoreJobs || loadingMoreJobs) return;
    setLoadingMoreJobs(true);
    try {
      const res = await fetchMoreJobs(jobsLastDoc, 50, false);
      const more = res.items || [];
      const nextLast = res.lastDoc || null;

      setJobs(prev => {
        const seen = new Set(prev.map(x => x.id));
        return [...prev, ...more.filter(x => !seen.has(x.id))];
      });

      setJobsLastDoc(nextLast);
      setHasMoreJobs(!!nextLast);
    } catch (e) {
      console.error("loadMoreJobs error:", e);
    } finally {
      setLoadingMoreJobs(false);
    }
  };

  const emptyJob = { name: "", area: "", genre: "", salary: "", tags: [], active: true, photo: false, introCount: 0, taikenCount: 0 };

  const toggleActive = async (id) => { const job = jobs.find(j => j.id === id); if (job) await toggleJobActive(id, !job.active); };
  const deleteJob = async (id) => { if (window.confirm("この求人を削除しますか？")) await deleteJobDoc(id); };
  const startEdit = (job) => { setEditing({ ...job, staffComment: job.staffComment || "", photoFiles: job.photoUrls || [] }); setShowForm(true); };
  const startNew = () => { setEditing({ ...emptyJob, id: Date.now(), isNew: true }); setShowForm(true); };
  const saveJob = async () => {
    if (!editing.name || !editing.area || saving) return;
    setSaving(true);
    try {
      const jobData = {
        shopName: editing.name,
        area: editing.area,
        genre: editing.genre || "",
        salaryDisplay: editing.salary || "",
        tags: editing.tags || [],
        staffComment: editing.staffComment || "",
        active: editing.active !== false };
      let jobId = editing.id;
      if (editing.isNew) {
        jobId = await createJob(jobData);
      } else {
        await updateJob(editing.id, jobData);
      }
      // Upload photos to Firebase Storage
      if (editing.photoFiles && editing.photoFiles.length > 0) {
        const { ref, uploadBytes, getDownloadURL } = await import("firebase/storage");
        const { storage } = await import("../config/firebase");
        const { doc: fsDoc, setDoc: fsSetDoc, serverTimestamp: fsTs } = await import("firebase/firestore");
        const { db: fsDb } = await import("../config/firebase");
        const urls = [];
        for (const file of editing.photoFiles) {
          if (typeof file === "string") { urls.push(file); continue; }
          const sRef = ref(storage, "jobs/" + jobId + "/photo_" + Date.now() + "_" + Math.random().toString(36).slice(2));
          const snap = await uploadBytes(sRef, file);
          const url = await getDownloadURL(snap.ref);
          urls.push(url);
        }
        await fsSetDoc(fsDoc(fsDb, "jobs", jobId), { photoUrls: urls, updatedAt: fsTs() }, { merge: true });
      }
      setShowForm(false); setEditing(null);
    } catch (e) {
      console.error("Save job error:", e);
      alert("保存に失敗しました。");
    }
    setSaving(false);
  };

  const [tagInput, setTagInput] = useState("");
  const addTag = () => { if (tagInput.trim() && editing) { setEditing({ ...editing, tags: [...editing.tags, tagInput.trim()] }); setTagInput(""); } };
  const removeTag = (idx) => { if (editing) setEditing({ ...editing, tags: editing.tags.filter((_, i) => i !== idx) }); };

  if (showForm && editing) {
    return (
      <div className="adm-jobform">
        <div className="adm-jobform__header">
          <button className="adm-detail__back" onClick={() => { setShowForm(false); setEditing(null); }}>← 戻る</button>
          <h2 className="adm-jobform__title">{editing.introCount > 0 ? "求人を編集" : "新規求人登録"}</h2>
        </div>
        <div className="adm-jobform__fields">
          <div className="adm-jf-field"><label className="adm-label">店舗名 *</label><input className="adm-input" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} placeholder="例：Club Lumière" /></div>
          <div className="adm-jf-row">
            <div className="adm-jf-field adm-jf-field--half"><label className="adm-label">エリア *</label><input className="adm-input" value={editing.area} onChange={e => setEditing({ ...editing, area: e.target.value })} placeholder="例：六本木" /></div>
            <div className="adm-jf-field adm-jf-field--half"><label className="adm-label">ジャンル</label><input className="adm-input" value={editing.genre} onChange={e => setEditing({ ...editing, genre: e.target.value })} placeholder="例：キャバクラ" /></div>
          </div>
          <div className="adm-jf-field"><label className="adm-label">時給</label><input className="adm-input" value={editing.salary} onChange={e => setEditing({ ...editing, salary: e.target.value })} placeholder="例：5,000〜8,000円" /></div>
          <div className="adm-jf-field"><label className="adm-label">おすすめコメント</label><textarea className="adm-input" style={{minHeight:"80px",resize:"vertical"}} value={editing.staffComment || ""} onChange={e => setEditing({ ...editing, staffComment: e.target.value })} placeholder="例：六本木でもトップクラスの客層の良さが魅力。未経験でも安心して働けます。" /></div>
          <div className="adm-jf-field">
            <label className="adm-label">タグ</label>
            <div className="adm-jf-tags">
              {editing.tags.map((t, i) => <span key={i} className="adm-jf-tag">{t}<button onClick={() => removeTag(i)}>×</button></span>)}
            </div>
            <div className="adm-jf-tag-input">
              <input className="adm-input" value={tagInput} onChange={e => setTagInput(e.target.value)} onKeyDown={e => e.key === "Enter" && (e.preventDefault(), addTag())} placeholder="タグを追加..." />
              <button className="adm-jf-tag-add" onClick={addTag}>追加</button>
            </div>
          </div>
          <div className="adm-jf-field">
            <label className="adm-label">店舗写真（最大3枚）</label>
            <div className="adm-jf-photos">
              {(editing.photoFiles || []).map((f, i) => (
                <div key={i} className="adm-jf-photo-thumb">
                  <img src={typeof f === "string" ? f : URL.createObjectURL(f)} alt="" />
                  <button className="adm-jf-photo-remove" onClick={() => { const pf = [...(editing.photoFiles || [])]; pf.splice(i, 1); setEditing({...editing, photoFiles: pf, photo: pf.length > 0}); }}>×</button>
                </div>
              ))}
              {(editing.photoFiles || []).length < 3 && (
                <label className="adm-jf-photo-add">
                  <span>＋</span>
                  <input type="file" accept="image/*" style={{ display: "none" }} onChange={(e) => { const f = e.target.files?.[0]; if (f) { const pf = [...(editing.photoFiles || []), f]; setEditing({...editing, photoFiles: pf, photo: true}); } }} />
                </label>
              )}
            </div>
          </div>
          <div className="adm-jf-field">
            <label className="adm-label">公開ステータス</label>
            <button className={`adm-jf-toggle ${editing.active ? "adm-jf-toggle--on" : ""}`} onClick={() => setEditing({ ...editing, active: !editing.active })}>
              <span className="adm-jf-toggle__dot" />
              <span className="adm-jf-toggle__label">{editing.active ? "公開中" : "非公開"}</span>
            </button>
          </div>
        </div>
        <button className="adm-jf-save" onClick={saveJob} disabled={saving}>{saving ? "保存中..." : "保存する"}</button>
      </div>
    );
  }

  return (
    <div className="adm-jobmgr">
      <div className="adm-jobmgr__header">
        <h2 className="adm-jobmgr__title">求人管理 <span className="adm-ulist__count">{jobs.length}件</span></h2>
        <button className="adm-jobmgr__add" onClick={startNew}>＋ 新規登録</button>
      </div>
      <div className="adm-jobmgr__list">
        {jobs.map(j => (
          <div key={j.id} className="adm-jcard">
            <div className="adm-jcard__top">
              <div className="adm-jcard__info">
                <div className="adm-jcard__name">{j.name}</div>
                <div className="adm-jcard__meta">{j.area} ・ {j.genre} ・ 時給 {j.salary}</div>
              </div>
              <span className={`adm-jcard__active ${j.active ? "adm-jcard__active--on" : "adm-jcard__active--off"}`} onClick={(e) => { e.stopPropagation(); toggleActive(j.id); }}>{j.active ? "公開中" : "非公開"}</span>
            </div>
            <div className="adm-jcard__tags">{j.tags.map((t, i) => <span key={i} className="adm-jcard__tag">{t}</span>)}</div>
            <div className="adm-jcard__bottom">
              <div className="adm-jcard__stats">
                <span>{j.photo ? "📷 " + (j.photoUrls?.length || 1) + "枚" : "📷 写真なし"}</span>
              </div>
              <div className="adm-jcard__actions">
                <button className="adm-jcard__btn" onClick={() => startEdit(j)}>編集</button>
                <button className="adm-jcard__btn adm-jcard__btn--danger" onClick={() => deleteJob(j.id)}>削除</button>
              </div>
            </div>
          </div>
        ))}
      
        <div style={{ textAlign: "center", padding: "16px 0" }}>
          {hasMoreJobs && (
            <button
              className="adm-jobmgr__add"
              onClick={loadMoreJobs}
              disabled={loadingMoreJobs}
              style={{ opacity: loadingMoreJobs ? 0.6 : 1 }}
            >
              {loadingMoreJobs ? "読み込み中..." : "もっと見る"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function TaikenList({ items }) {
  return (
    <div className="adm-taiken">
      <div className="adm-taiken__header"><h2 className="adm-taiken__title">体験入店管理</h2></div>
      {items.length === 0 && <div style={{textAlign:"center",padding:"40px 0",color:"rgba(245,239,230,.3)",fontSize:"13px"}}>まだ体験入店の申し込みはありません</div>}
      <div className="adm-taiken__list">
        {items.map(t => (
          <div key={t.id} className="adm-taiken__card">
            <div className="adm-taiken__card-top">
              <div><div className="adm-taiken__user">{t.userName}さん</div><div className="adm-taiken__shop">{t.shop}（{t.area}）</div></div>
              <span className="adm-taiken__status" style={{ background: TAIKEN_COLORS[t.status]?.bg, color: TAIKEN_COLORS[t.status]?.color }}>{t.status}</span>
            </div>
            <div className="adm-taiken__date">{t.date} {t.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── Main ── */

function StaffLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email.trim() || !password.trim()) { setError("メールアドレスとパスワードを入力してください"); return; }
    setError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onLogin();
    } catch (e) {
      console.error(e);
      setError("ログインに失敗しました。メールアドレスとパスワードを確認してください。");
    }
    setLoading(false);
  };

  return (
    <div className="adm-login">
      <div className="adm-login__card">
        <div className="adm-login__icon"><img src={ICON_MD} alt="DressWork" /></div>
        <h1 className="adm-login__title">DressWork</h1>
        <p className="adm-login__subtitle">スタッフ管理画面</p>
        <div className="adm-login__form">
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="メールアドレス" className="adm-login__input" onKeyDown={e => e.key === "Enter" && handleLogin()} />
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="パスワード" className="adm-login__input" onKeyDown={e => e.key === "Enter" && handleLogin()} />
          {error && <p className="adm-login__error">{error}</p>}
          <button onClick={handleLogin} disabled={loading} className={`adm-login__btn ${loading ? "adm-login__btn--loading" : ""}`}>
            {loading ? "ログイン中..." : "ログイン"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [page, setPage] = useState("users");
  const [selectedUser, setSelectedUser] = useState(null);
  const [sendJobUser, setSendJobUser] = useState(null);
  const [sideCollapsed, setSideCollapsed] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersLastDoc, setUsersLastDoc] = useState(null);
  const [loadingMoreUsers, setLoadingMoreUsers] = useState(false);
  const [hasMoreUsers, setHasMoreUsers] = useState(true);
  const [taikenList, setTaikenList] = useState([]);
  const [staffUser, setStaffUser] = useState(null);
  const [authChecking, setAuthChecking] = useState(true);
  const [toasts, setToasts] = useState([]);
  const prevCounts = useRef({ users: -1, taiken: -1 });
  const addToast = (msg, type = "info") => {
    const id = Date.now();
    setToasts(p => [...p, { id, msg, type }]);
    setTimeout(() => setToasts(p => p.filter(t => t.id !== id)), 5000);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        // Check if user exists in staff collection
        try {
          const { doc, getDoc } = await import("firebase/firestore");
          const { db } = await import("../config/firebase");
          const staffSnap = await getDoc(doc(db, "staff", user.uid));
          if (staffSnap.exists()) {
            setStaffUser(user);
            // Setup push notifications for staff
            try {
              const { requestNotificationPermission } = await import("../services/pushService");
              await requestNotificationPermission(user.uid);
            } catch (e) { console.log("Staff push setup skipped:", e); }
          } else {
            // Not a staff member - sign out
            await signOut(auth);
            setStaffUser(null);
          }
        } catch (e) {
          console.error("Staff check error:", e);
          setStaffUser(null);
        }
      } else {
        setStaffUser(null);
      }
      setAuthChecking(false);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    setStaffUser(null);
  };

  useEffect(() => {
    const unsubUsers = subscribeLatestUsers(({ items, lastDoc }) => {

      const formatted = items.map(u => ({
        id: u.id,
        name: u.name || "名前未設定",
        age: u.ageRange || "",
        status: u.status || "新規登録",
        date: u.createdAt?.toDate ? u.createdAt.toDate().toLocaleDateString("ja-JP") : "",
        experience: u.experience || "",
        area: u.area || "",
        salary: u.salary || "",
        schedule: u.schedule || "",
        priority: u.priority || "",
        height: u.height || "",
        weight: u.weight || "",
        phone: u.phone || "",
        line: u.lineId || "",
        photoUrls: u.photoUrls || [],
        unread: 0 }));
      if (prevCounts.current.users >= 0 && formatted.length > prevCounts.current.users) {
        const newUser = formatted[0];
        addToast("新規ユーザー: " + newUser.name + "さんが登録しました", "user");
      }
      prevCounts.current.users = formatted.length;
      setUsers(formatted);
    
      setUsersLastDoc(lastDoc || null);
      setHasMoreUsers(!!lastDoc);
    }, 50);
const unsubTaiken = subscribeTaikenApplications((data) => {
      const mapped = data.map(t => ({
        id: t.id,
        userName: t.userId,
        shopName: t.shopName || t.jobId,
        shop: t.jobId,
        area: t.area || "",
        date: t.confirmedDate || t.preferredDate || "",
        time: t.confirmedTime || "",
        status: t.status === "applied" ? "申込み" : t.status === "adjusting" ? "調整中" : t.status === "confirmed" ? "確定" : t.status === "completed" ? "完了" : t.status }));
      if (prevCounts.current.taiken >= 0 && mapped.length > prevCounts.current.taiken) {
        const newApp = mapped[0];
        addToast("体験入店申込: " + (newApp.shopName || "店舗") + "への申込みがありました", "taiken");
      }
      prevCounts.current.taiken = mapped.length;
      setTaikenList(mapped);
    });
    // Subscribe to chat rooms for new message notifications
    let unsubChats = () => {};
    (async () => {
      try {
        const { collection: col, query: q, orderBy: ob, onSnapshot: snap } = await import("firebase/firestore");
        const { db } = await import("../config/firebase");
        const chatQ = q(col(db, "chatRooms"), ob("lastMessageAt", "desc"));
        let prevLastMsg = null;
        unsubChats = snap(chatQ, (snapshot) => {
          if (snapshot.docs.length > 0) {
            const latest = snapshot.docs[0].data();
            if (prevLastMsg !== null && latest.lastMessage !== prevLastMsg && latest.staffUnread > 0) {
              addToast("新着メッセージ: " + latest.lastMessage, "message");
            }
            prevLastMsg = latest.lastMessage;
          }
        });
      } catch (e) { console.error("Chat watch error:", e); }
    })();

    return () => { unsubUsers(); unsubTaiken(); unsubChats(); };
  }, []);


  const loadMoreUsers = async () => {
    if (!hasMoreUsers || loadingMoreUsers) return;
    setLoadingMoreUsers(true);
    try {
      const res = await fetchMoreUsers(usersLastDoc, 50);
      const more = res.items || [];
      const nextLast = res.lastDoc || null;

      // 既存と重複しないように結合
      setUsers(prev => {
        const seen = new Set(prev.map(x => x.id));
        return [...prev, ...more.filter(x => !seen.has(x.id))];
      });

      setUsersLastDoc(nextLast);
      setHasMoreUsers(!!nextLast);
    } catch (e) {
      console.error("loadMoreUsers error:", e);
    } finally {
      setLoadingMoreUsers(false);
    }
  };

    if (authChecking) return <div style={{ minHeight: "100vh", background: "#1a1416" }} />;
  if (!staffUser) return <StaffLogin onLogin={() => {}} />;



  return (
    <div className="adm">
      <Sidebar active={page} onNav={(p) => { setPage(p); setSelectedUser(null); }} collapsed={sideCollapsed} onToggle={() => setSideCollapsed(!sideCollapsed)} onLogout={handleLogout} />

      <div className="adm-main">
        {/* Top bar for mobile */}
        <div className="adm-topbar">
          <div className="adm-topbar__left">
            <img src={ICON_MD} alt="DW" className="adm-topbar__icon" />
            <span className="adm-topbar__title">DressWork <small>管理画面</small></span>
          </div>
          <button className="adm-topbar__logout" onClick={handleLogout}>ログアウト</button>
        </div>

        <div className="adm-content">
          {page === "users" && !selectedUser && (
            <UserList users={users} onSelect={setSelectedUser} selectedId={null}  hasMoreUsers={hasMoreUsers}  loadingMoreUsers={loadingMoreUsers}  loadMoreUsers={loadMoreUsers} />
          )}
          {page === "users" && selectedUser && (
            <UserDetail user={selectedUser} onBack={() => setSelectedUser(null)} onSendJob={setSendJobUser} />
          )}
          {page === "taiken" && <TaikenList items={taikenList} />}
          {page === "jobs" && <JobManager />}
        </div>

        <MobileNav active={page} onNav={(p) => { setPage(p); setSelectedUser(null); }} />
      </div>

      {sendJobUser && <SendJobModal user={sendJobUser} onClose={() => setSendJobUser(null)} />}

      {/* Toast notifications */}
      <div className="adm-toasts">
        {toasts.map(t => (
          <div key={t.id} className={"adm-toast adm-toast--" + t.type} onClick={() => setToasts(p => p.filter(x => x.id !== t.id))}>
            <span className="adm-toast__icon">{t.type === "user" ? "👤" : t.type === "taiken" ? "🏠" : "💬"}</span>
            <span className="adm-toast__msg">{t.msg}</span>
          </div>
        ))}
      </div>

      <style>{`
@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@400;500;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{--gold:#d4af6e;--gold-dk:#c49a50;--gold-lt:#f0d48a;--dark:#1a1416;--dark-m:#2a2024;--dark-l:#322a2e;--ivory:#f5efe6;--fb:'Zen Kaku Gothic New',-apple-system,sans-serif}
body{background:var(--dark)}

.adm{display:flex;height:100vh;height:100dvh;font-family:var(--fb);color:var(--ivory);overflow:hidden}

/* Sidebar (desktop) */
.adm-side{width:220px;background:var(--dark);border-right:1px solid rgba(212,175,110,.06);display:none;flex-direction:column;flex-shrink:0;transition:width .3s ease}
.adm-side--collapsed{width:64px}
.adm-side__logo{padding:18px 16px;display:flex;align-items:center;gap:10px;border-bottom:1px solid rgba(212,175,110,.06)}
.adm-side__logo-img{width:34px;height:34px;border-radius:10px;object-fit:cover;flex-shrink:0}
.adm-side__logo-text{font-size:14px;font-weight:700;color:var(--ivory);letter-spacing:.03em;line-height:1.2}
.adm-side__logo-text small{display:block;font-size:10px;color:rgba(212,175,110,.4);font-weight:500;margin-top:1px}
.adm-side__nav{flex:1;padding:12px 8px}
.adm-side__item{display:flex;align-items:center;gap:10px;width:100%;padding:11px 12px;border-radius:10px;border:none;background:transparent;color:rgba(245,239,230,.5);font-size:13px;font-weight:500;cursor:pointer;font-family:var(--fb);transition:all .2s;text-align:left}
.adm-side__item:hover{background:rgba(212,175,110,.06);color:rgba(245,239,230,.8)}
.adm-side__item--active{background:rgba(212,175,110,.1)!important;color:var(--gold)!important;font-weight:700}
.adm-side__icon{font-size:16px;flex-shrink:0;width:20px;text-align:center}
.adm-side__toggle{margin:8px;padding:8px;border-radius:8px;border:1px solid rgba(212,175,110,.08);background:transparent;color:rgba(212,175,110,.4);cursor:pointer;font-size:12px;font-family:var(--fb)}

/* Main */
.adm-main{flex:1;display:flex;flex-direction:column;overflow:hidden;background:linear-gradient(170deg,var(--dark-m) 0%,#1e181c 100%)}

/* Top bar (mobile) */
.adm-topbar{padding:14px 16px;display:flex;align-items:center;border-bottom:1px solid rgba(212,175,110,.06);background:rgba(26,20,22,.8);backdrop-filter:blur(20px)}
.adm-topbar__left{display:flex;align-items:center;gap:8px}
.adm-topbar__icon{width:30px;height:30px;border-radius:8px;object-fit:cover}
.adm-topbar__title{font-size:14px;font-weight:700;color:var(--ivory);letter-spacing:.03em}
.adm-topbar__title small{color:rgba(212,175,110,.4);font-weight:500;margin-left:4px}

/* Content */
.adm-content{flex:1;overflow-y:auto;padding:16px}

/* Mobile bottom nav */
.adm-mnav{display:flex;border-top:1px solid rgba(212,175,110,.06);background:rgba(26,20,22,.9);backdrop-filter:blur(20px)}
.adm-mnav__item{flex:1;display:flex;flex-direction:column;align-items:center;gap:3px;padding:10px 0 14px;border:none;background:transparent;color:rgba(245,239,230,.35);font-size:10px;font-weight:600;cursor:pointer;font-family:var(--fb)}
.adm-mnav__item--active{color:var(--gold)}
.adm-mnav__item span:first-child{font-size:18px}

/* User list */
.adm-ulist__header{margin-bottom:16px}
.adm-ulist__title{font-size:18px;font-weight:700;color:var(--ivory)}
.adm-ulist__count{font-size:13px;color:rgba(212,175,110,.4);font-weight:500;margin-left:6px}
.adm-ulist__filters{display:flex;gap:8px;margin-bottom:14px;flex-wrap:wrap}
.adm-search{flex:1;min-width:160px;padding:10px 14px;border-radius:10px;border:1px solid rgba(212,175,110,.1);background:rgba(255,255,255,.03);color:var(--ivory);font-size:13px;outline:none;font-family:var(--fb)}
.adm-search::placeholder{color:rgba(212,175,110,.25)}
.adm-search:focus{border-color:rgba(212,175,110,.3)}
.adm-select{padding:10px 12px;border-radius:10px;border:1px solid rgba(212,175,110,.1);background:var(--dark-m);color:var(--ivory);font-size:12px;font-family:var(--fb);outline:none;cursor:pointer}

.adm-ucard{display:flex;align-items:center;gap:12px;padding:14px;border-radius:14px;border:1px solid rgba(212,175,110,.06);background:rgba(255,255,255,.02);cursor:pointer;transition:all .2s;margin-bottom:8px}
.adm-ucard:hover{background:rgba(212,175,110,.04);border-color:rgba(212,175,110,.12)}
.adm-ucard--active{background:rgba(212,175,110,.08)!important;border-color:rgba(212,175,110,.2)!important}
.adm-ucard__avatar{width:40px;height:40px;border-radius:50%;background:linear-gradient(135deg,rgba(212,175,110,.15),rgba(196,154,80,.08));display:flex;align-items:center;justify-content:center;color:var(--gold);font-weight:700;font-size:15px;flex-shrink:0}
.adm-ucard__info{flex:1;min-width:0}
.adm-ucard__name{font-size:14px;font-weight:700;color:var(--ivory)}
.adm-ucard__age{font-size:12px;color:rgba(245,239,230,.4);font-weight:400;margin-left:4px}
.adm-ucard__meta{font-size:11px;color:rgba(245,239,230,.3);margin-top:2px}
.adm-ucard__right{display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0}
.adm-ucard__status{font-size:10px;font-weight:600;padding:4px 10px;border-radius:12px;white-space:nowrap}
.adm-ucard__badge{width:20px;height:20px;border-radius:50%;background:var(--gold);color:var(--dark);font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center}

/* User detail */
.adm-detail__header{display:flex;align-items:center;gap:12px;margin-bottom:16px;flex-wrap:wrap}
.adm-detail__back{padding:8px 14px;border-radius:8px;border:1px solid rgba(212,175,110,.12);background:transparent;color:rgba(212,175,110,.6);font-size:12px;cursor:pointer;font-family:var(--fb);white-space:nowrap}
.adm-detail__user{display:flex;align-items:center;gap:10px;flex:1}
.adm-detail__avatar{width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,rgba(212,175,110,.15),rgba(196,154,80,.08));display:flex;align-items:center;justify-content:center;color:var(--gold);font-weight:700;font-size:15px;flex-shrink:0}
.adm-detail__name{font-size:16px;font-weight:700;color:var(--ivory)}
.adm-detail__name span{font-size:13px;color:rgba(245,239,230,.4);font-weight:400;margin-left:4px}
.adm-detail__status{font-size:10px;font-weight:600;padding:3px 8px;border-radius:10px;display:inline-block;margin-top:2px}
.adm-detail__send-btn{padding:9px 18px;border-radius:10px;border:none;background:linear-gradient(135deg,var(--gold),var(--gold-dk));color:var(--dark);font-size:12px;font-weight:700;cursor:pointer;font-family:var(--fb);white-space:nowrap}

.adm-detail__tabs{display:flex;gap:4px;margin-bottom:16px;border-bottom:1px solid rgba(212,175,110,.06);padding-bottom:0}
.adm-detail__tab{padding:10px 20px;border:none;background:transparent;color:rgba(245,239,230,.4);font-size:13px;font-weight:600;cursor:pointer;font-family:var(--fb);border-bottom:2px solid transparent;transition:all .2s}
.adm-detail__tab--active{color:var(--gold);border-bottom-color:var(--gold)}

/* Info tab */
.adm-detail__info{display:flex;flex-direction:column;gap:16px}
.adm-info-section{background:rgba(255,255,255,.02);border:1px solid rgba(212,175,110,.06);border-radius:14px;padding:16px}
.adm-info-section__title{font-size:12px;font-weight:700;color:var(--gold);letter-spacing:.06em;margin-bottom:12px;text-transform:uppercase}

.adm-info-photos{display:flex;gap:10px;flex-wrap:wrap}
.adm-info-photo{width:120px;height:160px;object-fit:cover;border-radius:12px;border:1px solid rgba(212,175,110,.12)}
.adm-info-row{display:flex;justify-content:space-between;padding:7px 0;border-bottom:1px solid rgba(212,175,110,.04);font-size:13px}
.adm-info-row:last-child{border-bottom:none}
.adm-info-row__k{color:rgba(245,239,230,.4);font-weight:500}
.adm-info-row__v{color:var(--ivory);font-weight:600}

/* Chat tab */
.adm-detail__chat{display:flex;flex-direction:column;height:calc(100vh - 280px);min-height:300px;background:rgba(255,255,255,.01);border:1px solid rgba(212,175,110,.06);border-radius:14px;overflow:hidden}
.adm-chat__msgs{flex:1;overflow-y:auto;padding:16px}
.adm-chat__msg{display:flex;margin-bottom:10px;gap:8px}
.adm-chat__msg--staff{justify-content:flex-end}
.adm-chat__msg--user{justify-content:flex-start}
.adm-chat__msg-avatar{width:28px;height:28px;border-radius:50%;background:linear-gradient(135deg,rgba(212,175,110,.15),rgba(196,154,80,.08));display:flex;align-items:center;justify-content:center;color:var(--gold);font-weight:700;font-size:11px;flex-shrink:0;margin-top:2px}
.adm-chat__msg-bubble{max-width:75%;padding:10px 14px;font-size:13px;line-height:1.7;border-radius:16px}
.adm-chat__msg-bubble--user{background:rgba(255,255,255,.05);border:1px solid rgba(212,175,110,.06);color:rgba(245,239,230,.75);border-radius:2px 16px 16px 16px}
.adm-chat__msg-bubble--staff{background:linear-gradient(135deg,var(--gold),var(--gold-dk));color:var(--dark);font-weight:600;border-radius:16px 2px 16px 16px}
.adm-chat__input{display:flex;gap:8px;padding:12px;border-top:1px solid rgba(212,175,110,.06)}
.adm-chat__field{flex:1;padding:10px 14px;border-radius:10px;border:1px solid rgba(212,175,110,.1);background:rgba(255,255,255,.03);color:var(--ivory);font-size:13px;outline:none;font-family:var(--fb);resize:none;max-height:120px;line-height:1.5;overflow-y:auto}
.adm-chat__field::placeholder{color:rgba(212,175,110,.25)}
.adm-chat__field:focus{border-color:rgba(212,175,110,.3)}
.adm-chat__img{max-width:180px;border-radius:10px;cursor:pointer;border:1px solid rgba(212,175,110,.12)}
.adm-chat__img-btn{display:flex;align-items:center;justify-content:center;width:38px;height:38px;border-radius:50%;background:rgba(212,175,110,.08);border:1px solid rgba(212,175,110,.1);cursor:pointer;font-size:16px;flex-shrink:0}
.adm-photo-viewer{position:fixed;inset:0;background:rgba(0,0,0,.9);z-index:60;display:flex;align-items:center;justify-content:center;padding:20px;cursor:pointer}
.adm-photo-viewer__img{max-width:100%;max-height:90vh;object-fit:contain;border-radius:8px}
.adm-photo-viewer__close{position:absolute;top:16px;right:16px;width:40px;height:40px;border-radius:50%;background:rgba(255,255,255,.15);border:none;color:#fff;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.adm-chat__send{padding:10px 20px;border-radius:10px;border:none;background:linear-gradient(135deg,var(--gold),var(--gold-dk));color:var(--dark);font-size:13px;font-weight:700;cursor:pointer;font-family:var(--fb);white-space:nowrap}

/* Taiken */
.adm-taiken__header{margin-bottom:16px}
.adm-taiken__title{font-size:18px;font-weight:700;color:var(--ivory)}
.adm-taiken__card{padding:16px;border-radius:14px;border:1px solid rgba(212,175,110,.06);background:rgba(255,255,255,.02);margin-bottom:10px}
.adm-taiken__card-top{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:8px}
.adm-taiken__user{font-size:14px;font-weight:700;color:var(--ivory)}
.adm-taiken__shop{font-size:12px;color:rgba(212,175,110,.5);margin-top:2px}
.adm-taiken__status{font-size:10px;font-weight:600;padding:4px 10px;border-radius:12px;white-space:nowrap}
.adm-taiken__date{font-size:13px;color:rgba(245,239,230,.6);font-weight:500}

/* Modal */
.adm-modal-overlay{position:fixed;inset:0;background:rgba(0,0,0,.7);backdrop-filter:blur(6px);z-index:50;display:flex;align-items:center;justify-content:center;padding:16px}
.adm-modal{width:100%;max-width:440px;background:var(--dark-m);border-radius:20px;border:1px solid rgba(212,175,110,.1);overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.5);max-height:90vh;overflow-y:auto}
.adm-modal__header{display:flex;justify-content:space-between;align-items:center;padding:18px 20px 14px;border-bottom:1px solid rgba(212,175,110,.06)}
.adm-modal__header h3{font-size:15px;font-weight:700;color:var(--ivory)}
.adm-modal__close{width:30px;height:30px;border-radius:50%;border:1px solid rgba(212,175,110,.1);background:rgba(255,255,255,.03);color:rgba(245,239,230,.4);font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.adm-modal__body{padding:20px}
.adm-modal__hint{font-size:12px;color:rgba(245,239,230,.4);margin-bottom:14px}
.adm-modal__jobs{display:flex;flex-direction:column;gap:8px;margin-bottom:16px}
.adm-modal__job{display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:12px;border:1px solid rgba(212,175,110,.08);background:rgba(255,255,255,.02);cursor:pointer;transition:all .2s}
.adm-modal__job--checked{border-color:var(--gold);background:rgba(212,175,110,.06)}
.adm-modal__job-check{width:22px;height:22px;border-radius:6px;border:2px solid rgba(212,175,110,.2);display:flex;align-items:center;justify-content:center;color:var(--gold);font-size:12px;font-weight:700;flex-shrink:0}
.adm-modal__job--checked .adm-modal__job-check{border-color:var(--gold);background:rgba(212,175,110,.15)}
.adm-modal__job-name{font-size:13px;font-weight:700;color:var(--ivory)}
.adm-modal__job-meta{font-size:11px;color:rgba(245,239,230,.35);margin-top:2px}
.adm-modal__textarea{width:100%;padding:12px 14px;border-radius:12px;border:1px solid rgba(212,175,110,.1);background:rgba(255,255,255,.03);color:var(--ivory);font-size:13px;font-family:var(--fb);resize:none;outline:none;margin-bottom:14px}
.adm-modal__textarea::placeholder{color:rgba(212,175,110,.25)}
.adm-modal__submit{width:100%;padding:13px 0;border-radius:12px;border:none;background:linear-gradient(135deg,var(--gold),var(--gold-dk));color:var(--dark);font-size:14px;font-weight:700;cursor:pointer;font-family:var(--fb)}
.adm-modal__done{text-align:center;padding:32px 20px}
.adm-modal__done-check{width:50px;height:50px;border-radius:50%;background:linear-gradient(135deg,#4ade80,#22c55e);display:flex;align-items:center;justify-content:center;margin:0 auto 14px;font-size:22px;color:#fff}
.adm-modal__done h3{font-size:17px;font-weight:700;color:var(--ivory);margin-bottom:6px}
.adm-modal__done p{font-size:13px;color:rgba(245,239,230,.45);margin-bottom:18px}

/* Job Manager */
.adm-jobmgr__header{display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;flex-wrap:wrap;gap:10px}
.adm-jobmgr__title{font-size:18px;font-weight:700;color:var(--ivory)}
.adm-jobmgr__add{padding:9px 18px;border-radius:10px;border:none;background:linear-gradient(135deg,var(--gold),var(--gold-dk));color:var(--dark);font-size:12px;font-weight:700;cursor:pointer;font-family:var(--fb);white-space:nowrap}

.adm-jcard{padding:16px;border-radius:14px;border:1px solid rgba(212,175,110,.06);background:rgba(255,255,255,.02);margin-bottom:10px;transition:all .2s}
.adm-jcard__top{display:flex;justify-content:space-between;align-items:flex-start;gap:10px;margin-bottom:8px}
.adm-jcard__info{flex:1;min-width:0}
.adm-jcard__name{font-size:15px;font-weight:700;color:var(--ivory)}
.adm-jcard__meta{font-size:11.5px;color:rgba(245,239,230,.4);margin-top:3px}
.adm-jcard__active{font-size:10px;font-weight:600;padding:4px 12px;border-radius:12px;cursor:pointer;white-space:nowrap;transition:all .2s}
.adm-jcard__active--on{background:rgba(74,222,128,.12);color:#4ade80}
.adm-jcard__active--off{background:rgba(245,239,230,.06);color:rgba(245,239,230,.35)}
.adm-jcard__tags{display:flex;flex-wrap:wrap;gap:5px;margin-bottom:10px}
.adm-jcard__tag{padding:3px 8px;border-radius:10px;background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.06);font-size:10px;color:rgba(245,239,230,.45);font-weight:500}
.adm-jcard__bottom{display:flex;justify-content:space-between;align-items:center}
.adm-jcard__stats{font-size:11px;color:rgba(245,239,230,.3)}
.adm-jcard__actions{display:flex;gap:6px}
.adm-jcard__btn{padding:6px 14px;border-radius:8px;border:1px solid rgba(212,175,110,.15);background:transparent;color:rgba(212,175,110,.6);font-size:11px;font-weight:600;cursor:pointer;font-family:var(--fb);transition:all .2s}
.adm-jcard__btn:hover{border-color:rgba(212,175,110,.35);color:var(--gold)}
.adm-jcard__btn--danger{border-color:rgba(239,68,68,.15);color:rgba(239,68,68,.5)}
.adm-jcard__btn--danger:hover{border-color:rgba(239,68,68,.4);color:#ef4444}

/* Job Form */
.adm-jobform__header{display:flex;align-items:center;gap:14px;margin-bottom:20px}
.adm-jobform__title{font-size:18px;font-weight:700;color:var(--ivory)}
.adm-jobform__fields{display:flex;flex-direction:column;gap:16px;margin-bottom:20px}
.adm-jf-field{display:flex;flex-direction:column;gap:6px}
.adm-jf-field--half{flex:1}
.adm-jf-row{display:flex;gap:12px}
.adm-label{font-size:11.5px;font-weight:700;color:rgba(212,175,110,.6);letter-spacing:.02em}
.adm-input{width:100%;padding:11px 14px;border-radius:10px;border:1px solid rgba(212,175,110,.12);background:rgba(255,255,255,.03);color:var(--ivory);font-size:13px;outline:none;font-family:var(--fb)}
.adm-input::placeholder{color:rgba(212,175,110,.25)}
.adm-input:focus{border-color:rgba(212,175,110,.35)}
.adm-jf-tags{display:flex;flex-wrap:wrap;gap:6px;min-height:20px}
.adm-jf-tag{display:inline-flex;align-items:center;gap:4px;padding:4px 10px;border-radius:10px;background:rgba(212,175,110,.1);color:var(--gold);font-size:11px;font-weight:600}
.adm-jf-tag button{background:none;border:none;color:rgba(212,175,110,.5);cursor:pointer;font-size:12px;padding:0 2px}
.adm-jf-tag-input{display:flex;gap:8px}
.adm-jf-tag-add{padding:10px 16px;border-radius:10px;border:1px solid rgba(212,175,110,.15);background:transparent;color:rgba(212,175,110,.6);font-size:12px;font-weight:600;cursor:pointer;font-family:var(--fb);white-space:nowrap}
.adm-jf-photo{display:flex;align-items:center;gap:12px;flex-wrap:wrap}
.adm-jf-photo-btn{display:inline-flex;align-items:center;gap:6px;padding:10px 18px;border-radius:10px;border:1px dashed rgba(212,175,110,.2);background:rgba(255,255,255,.02);color:rgba(212,175,110,.5);font-size:12px;font-weight:600;cursor:pointer;font-family:var(--fb)}
.adm-jf-photo-status{font-size:12px;color:#4ade80;font-weight:600}
.adm-jf-toggle{display:flex;align-items:center;gap:10px;padding:8px 16px;border-radius:20px;border:1px solid rgba(212,175,110,.12);background:rgba(255,255,255,.02);cursor:pointer;font-family:var(--fb);transition:all .2s}
.adm-jf-toggle--on{border-color:rgba(74,222,128,.3);background:rgba(74,222,128,.06)}
.adm-jf-toggle__dot{width:16px;height:16px;border-radius:50%;background:rgba(245,239,230,.2);transition:all .2s}
.adm-jf-toggle--on .adm-jf-toggle__dot{background:#4ade80}
.adm-jf-toggle__label{font-size:12px;font-weight:600;color:rgba(245,239,230,.5)}
.adm-jf-toggle--on .adm-jf-toggle__label{color:#4ade80}

.adm-jf-photos{display:flex;gap:8px;flex-wrap:wrap;margin-top:6px}
.adm-jf-photo-thumb{position:relative;width:80px;height:80px;border-radius:10px;overflow:hidden;border:1px solid rgba(212,175,110,.12)}
.adm-jf-photo-thumb img{width:100%;height:100%;object-fit:cover}
.adm-jf-photo-remove{position:absolute;top:4px;right:4px;width:20px;height:20px;border-radius:50%;background:rgba(0,0,0,.6);color:#fff;border:none;font-size:12px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.adm-jf-photo-add{width:80px;height:80px;border-radius:10px;border:2px dashed rgba(212,175,110,.2);display:flex;align-items:center;justify-content:center;cursor:pointer;color:rgba(212,175,110,.4);font-size:24px;transition:all .2s}
.adm-jf-photo-add:hover{border-color:rgba(212,175,110,.4);color:rgba(212,175,110,.6)}
.adm-jf-save{width:100%;padding:14px 0;border-radius:12px;border:none;background:linear-gradient(135deg,var(--gold),var(--gold-dk));color:var(--dark);font-size:14px;font-weight:700;cursor:pointer;font-family:var(--fb);box-shadow:0 3px 14px rgba(212,175,110,.2)}

@media(max-width:480px){.adm-jf-row{flex-direction:column;gap:16px}}

/* ═══ TABLET 768px+ ═══ */
@media(min-width:768px){
  .adm-side{display:flex}
  .adm-topbar{display:none}
  .adm-mnav{display:none}
  .adm-content{padding:24px}
  .adm-detail__chat{height:calc(100vh - 240px)}
}

/* ═══ DESKTOP 1200px+ ═══ */
@media(min-width:1200px){
  .adm-content{padding:28px 32px}
  .adm-ulist__filters{flex-wrap:nowrap}
}

::-webkit-scrollbar{width:4px}
::-webkit-scrollbar-track{background:transparent}
::-webkit-scrollbar-thumb{background:rgba(212,175,110,.12);border-radius:3px}
      
/* Staff Login */
.adm-login{min-height:100vh;display:flex;align-items:center;justify-content:center;background:linear-gradient(170deg,#1a1416 0%,#2a2024 50%,#1e181c 100%);font-family:var(--fb);padding:20px}
.adm-login__card{width:100%;max-width:360px;text-align:center}
.adm-login__icon{width:64px;height:64px;border-radius:18px;overflow:hidden;margin:0 auto 16px;box-shadow:0 8px 32px rgba(212,175,110,.25)}
.adm-login__icon img{width:100%;height:100%;object-fit:cover}
.adm-login__title{font-size:24px;font-weight:300;color:var(--ivory);letter-spacing:.12em;font-family:'Cormorant Garamond',serif;margin-bottom:4px}
.adm-login__subtitle{font-size:12px;color:rgba(212,175,110,.5);font-weight:600;margin-bottom:32px;letter-spacing:.06em}
.adm-login__form{display:flex;flex-direction:column;gap:12px}
.adm-login__input{width:100%;padding:13px 16px;border-radius:12px;border:1.5px solid rgba(212,175,110,.12);background:rgba(255,255,255,.04);font-size:14px;color:var(--ivory);outline:none;font-family:var(--fb)}
.adm-login__input::placeholder{color:rgba(212,175,110,.25)}
.adm-login__input:focus{border-color:rgba(212,175,110,.4)}
.adm-login__error{font-size:12px;color:#ef4444;padding:8px 12px;border-radius:10px;background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.15);text-align:left}
.adm-login__btn{width:100%;padding:14px 0;border-radius:12px;border:none;background:linear-gradient(135deg,var(--gold),var(--gold-dk));color:var(--dark);font-size:14px;font-weight:700;cursor:pointer;font-family:var(--fb);box-shadow:0 4px 16px rgba(212,175,110,.25);margin-top:4px}
.adm-login__btn--loading{opacity:.6;cursor:not-allowed}

/* Logout buttons */
.adm-side__logout{margin:8px;padding:9px;border-radius:8px;border:1px solid rgba(239,68,68,.15);background:transparent;color:rgba(239,68,68,.5);cursor:pointer;font-size:11px;font-weight:600;font-family:var(--fb);transition:all .2s}
.adm-side__logout:hover{border-color:rgba(239,68,68,.35);color:#ef4444}
.adm-topbar__logout{padding:7px 14px;border-radius:8px;border:1px solid rgba(212,175,110,.12);background:transparent;color:rgba(212,175,110,.5);font-size:11px;font-weight:600;cursor:pointer;font-family:var(--fb);white-space:nowrap}

/* Toast notifications */
.adm-toasts{position:fixed;top:16px;right:16px;z-index:100;display:flex;flex-direction:column;gap:8px;max-width:360px;width:calc(100% - 32px)}
.adm-toast{display:flex;align-items:center;gap:10px;padding:14px 18px;border-radius:14px;background:var(--dark-m);border:1px solid rgba(212,175,110,.15);box-shadow:0 8px 32px rgba(0,0,0,.5);cursor:pointer;animation:adm-toast-in .3s ease}
.adm-toast--user{border-left:3px solid #4ade80}
.adm-toast--taiken{border-left:3px solid #fb923c}
.adm-toast--message{border-left:3px solid #60a5fa}
.adm-toast__icon{font-size:18px;flex-shrink:0}
.adm-toast__msg{font-size:13px;color:var(--ivory);font-weight:500;line-height:1.5}
@keyframes adm-toast-in{from{opacity:0;transform:translateX(20px)}to{opacity:1;transform:translateX(0)}}
`}</style>
    </div>
  );
}
